<script setup>
import {ref, onBeforeMount} from "vue"
import {getRoute} from "@/hooks/getRoute.js";
const {route} = getRoute()

const errMessage = ref("未知原因")
onBeforeMount(() => {
  if (route.query.message) {
    errMessage.value = route.query.message
  }
})
</script>

<template>
  <div class="wrapper">
    <div class="container">
      <h1>绑定失败</h1>
      <p class="mg_b_2">您的微信账号绑定失败!</p>
      <p>失败原因：{{errMessage}}</p>
    </div>
  </div>
</template>

<style scoped>
.wrapper {
  width: 100vw;
  height: 100vh;
  font-family: Arial, sans-serif;
  text-align: center;
  margin: 0;
  padding: 10px;
  background-color: #fff;
}
.container {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  margin: 0 auto;
  min-height: 165px;
  max-height: 400px;
}
h1 {
  color: #d23c22;
  font-size: 32px;
  margin: 21px 0;
}
</style>